class CollectionFilters extends HTMLElement {
  constructor() {
    super();

    this.filters_form = this.querySelector(".filters__form");
    this.events = [
      {
        el: window,
        type: "resize",
        callback: this.toggleFilterDisplay.bind(this),
      },
      {
        el: document,
        type: "click",
        callback: this.outsideClickHandler.bind(this),
      },
      {
        el: this.filters_form,
        type: "change",
        callback: this.changeHandler.bind(this),
      },
      {
        el: this.filters_form,
        type: "submit",
        callback: this.submitHandler.bind(this),
      },
      {
        el: this,
        type: "click",
        callback: this.clickHandler.bind(this),
      },
      {
        el: window,
        type: "popstate",
        callback: this.historyHandler.bind(this),
      },
    ];
    this.filters_drawer = this.querySelector(".filters__drawer");
    this.filters_button = this.querySelector(".filters__button");
    this.filters = this.querySelector(".filters__body");
    this.drawer_animation_duration = 300;

    this.toggleFilterDisplay();
  }
  connectedCallback() {
    handleEventListeners(this.events, "add");
  }
  disconnectedCallback() {
    handleEventListeners(this.events, "remove");
  }
  toggleFilterDisplay() {
    const is_mobile_drawer = this.isMobileDrawer();

    if (!is_mobile_drawer) {
      this.filters_drawer.open = true;
      this.filters_drawer.classList.remove("is-open", "is-closing");
    } else if (this.mobile_drawer_active !== true) {
      this.closeFiltersDrawer(false);
    }

    this.mobile_drawer_active = is_mobile_drawer;
  }
  outsideClickHandler(e) {
    if (
      this.isMobileDrawer() &&
      this.filters_drawer.open &&
      !this.filters.contains(e.target) &&
      !this.filters_button.contains(e.target)
    ) {
      this.closeFiltersDrawer();
    }

    this.querySelectorAll(".filter").forEach((filter) => {
      if (filter.open && !filter.contains(e.target)) {
        filter.open = false;
      }
    });
  }
  clickHandler(e) {
    if (e.target.closest(".filters__button") && this.isMobileDrawer()) {
      e.preventDefault();
      this.openFiltersDrawer();
      return;
    }

    if (e.target.closest("[data-filters-close]")) {
      this.closeFiltersDrawer();
      return;
    }

    if (this.querySelector(".filters__active-bar").contains(e.target)) {
      this.adjustActiveFilters(e);
    }
  }
  openFiltersDrawer() {
    this.filters_drawer.open = true;
    this.filters_drawer.classList.remove("is-closing");

    requestAnimationFrame(() => {
      this.filters_drawer.classList.add("is-open");
    });
  }
  closeFiltersDrawer(animate = true) {
    this.filters_drawer.classList.remove("is-open");

    if (!animate) {
      this.filters_drawer.open = false;
      this.filters_drawer.classList.remove("is-closing");
      return;
    }

    this.filters_drawer.classList.add("is-closing");
    clearTimeout(this.drawer_timer);
    this.drawer_timer = setTimeout(() => {
      this.filters_drawer.open = false;
      this.filters_drawer.classList.remove("is-closing");
    }, this.drawer_animation_duration);
  }
  isMobileDrawer() {
    return window.innerWidth <= 767;
  }
  submitHandler(e) {
    e.preventDefault();
  }
  changeHandler(e) {
    if (e?.target.closest("collection-price-range")) return;

    this.debounce(() => {
      this.applyFilters();
    });
  }
  historyHandler() {
    const filter_params = new URLSearchParams(window.location.search);
    this.syncFormWithParams(filter_params);
    this.applyFilters(filter_params, false);
  }
  async applyFilters(filter_params = this.createFilterParams(), update_history = true) {
    const fetch_params = new URLSearchParams(filter_params);
    fetch_params.set("section_id", this.dataset.sectionId);
    const section = this.closest("section");

    try {
      const response = await fetch(`${window.location.pathname}?${fetch_params.toString()}`);
      const html = await response.text();
      const parsed_doc = new DOMParser().parseFromString(html, "text/html");
      const new_grid = parsed_doc.querySelector(".product-grid, combined-product-grid");
      const current_grid = section.querySelector(".product-grid, combined-product-grid");
      if (new_grid && current_grid) {
        if (update_history) {
          this.updateHistory(filter_params);
        }
        current_grid.replaceWith(new_grid);
        const new_active_bar = parsed_doc.querySelector(".filters__active-bar");
        const current_active_bar = this.querySelector(".filters__active-bar");
        if (new_active_bar && current_active_bar) {
          current_active_bar.replaceWith(new_active_bar);
        }
      }
    } catch (error) {
      console.error("CollectionFilters: failed to fetch filtered products", error);
    }
  }
  syncFormWithParams(params) {
    this.filters_form.querySelectorAll("input[type='checkbox']").forEach((checkbox) => {
      checkbox.checked = params.getAll(checkbox.name).includes(checkbox.value);
    });
    this.filters_form.querySelectorAll("collection-price-range").forEach((price_range) => {
      price_range.syncFromParams(params);
    });
  }
  createFilterParams() {
    const filter_params = new URLSearchParams(new FormData(this.filters_form));
    const empty_keys = [];

    filter_params.forEach((value, key) => {
      if (!value) {
        empty_keys.push(key);
      }
    });
    empty_keys.forEach((key) => filter_params.delete(key));

    return filter_params;
  }
  adjustActiveFilters(e) {
    const active_value = e.target.closest(".filters__active-value");
    const clear_all = e.target.closest(".filters__clear-all");

    if (active_value) {
      const { filterName, filterValue } = active_value.dataset;
      const checkbox = this.filters_form.querySelector(
        `input[name="${filterName}"][value="${filterValue}"]`,
      );
      if (checkbox) {
        checkbox.checked = false;
      } else {
        const input = this.filters_form.querySelector(`input[name="${filterName}"]`);
        const price_range = input?.closest("collection-price-range");

        if (input) {
          input.value = "";
        }
        if (price_range) {
          price_range.syncHandlesWithInputs();
        }
      }
      if (checkbox || this.filters_form.querySelector(`input[name="${filterName}"]`)) {
        this.changeHandler();
      }
    } else if (clear_all) {
      this.filters_form
        .querySelectorAll("input[type='checkbox']")
        .forEach((filter) => (filter.checked = false));
      this.filters_form.querySelectorAll("collection-price-range").forEach((price_range) => {
        price_range.reset();
      });
      this.changeHandler();
    }
  }
  updateHistory(params) {
    const url = params.toString()
      ? `${window.location.pathname}?${params.toString()}`
      : window.location.pathname;
    history.pushState({ searchParams: params.toString() }, "", url);
  }
  debounce(fn, wait = 500) {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      fn.apply(this);
    }, wait);
  }
}
customElements.define("collection-filters", CollectionFilters);

class CollectionPriceRange extends HTMLElement {
  constructor() {
    super();

    this.min_input = this.querySelector("[data-price-input='min']");
    this.max_input = this.querySelector("[data-price-input='max']");
    this.min_range = this.querySelector("[data-price-range-handle='min']");
    this.max_range = this.querySelector("[data-price-range-handle='max']");
    this.range_fill = this.querySelector("[data-price-range-fill]");
    this.apply_button = this.querySelector("[data-price-apply]");
    this.min = this.parseValue(this.dataset.min, 0);
    this.max = this.parseValue(this.dataset.max, 0);
    this.events = [
      {
        el: this,
        type: "input",
        callback: this.inputHandler.bind(this),
      },
      {
        el: this,
        type: "change",
        callback: this.changeHandler.bind(this),
      },
      {
        el: this.apply_button,
        type: "click",
        callback: this.applyHandler.bind(this),
      },
    ];

    this.syncHandlesWithInputs();
  }

  connectedCallback() {
    handleEventListeners(this.events, "add");
  }

  disconnectedCallback() {
    handleEventListeners(this.events, "remove");
  }

  inputHandler(e) {
    const range_handle = e.target.dataset.priceRangeHandle;
    const price_input = e.target.dataset.priceInput;

    if (range_handle) {
      this.syncInputsWithHandles(range_handle);
    } else if (price_input) {
      this.syncHandlesWithInputs(price_input);
    }
  }

  changeHandler(e) {
    e.stopPropagation();
  }

  applyHandler() {
    this.normaliseInputs();
    this.closest("collection-filters")?.applyFilters();
  }

  syncFromParams(params) {
    this.min_input.value = params.get(this.min_input.name) || "";
    this.max_input.value = params.get(this.max_input.name) || "";
    this.syncHandlesWithInputs();
  }

  reset() {
    this.min_input.value = "";
    this.max_input.value = "";
    this.syncHandlesWithInputs();
  }

  syncInputsWithHandles(active_handle) {
    let min_value = this.parseValue(this.min_range.value, this.min);
    let max_value = this.parseValue(this.max_range.value, this.max);

    if (min_value > max_value) {
      if (active_handle === "min") {
        max_value = min_value;
      } else {
        min_value = max_value;
      }
    }

    this.min_range.value = min_value;
    this.max_range.value = max_value;
    this.min_input.value = min_value <= this.min ? "" : this.formatValue(min_value);
    this.max_input.value = max_value >= this.max ? "" : this.formatValue(max_value);
    this.updateRangeFill();
  }

  syncHandlesWithInputs(active_input) {
    let min_value = this.parseValue(this.min_input.value, this.min);
    let max_value = this.parseValue(this.max_input.value, this.max);

    min_value = this.clamp(min_value, this.min, this.max);
    max_value = this.clamp(max_value, this.min, this.max);

    if (min_value > max_value) {
      if (active_input === "min") {
        max_value = min_value;
      } else {
        min_value = max_value;
      }
    }

    this.min_range.value = min_value;
    this.max_range.value = max_value;
    this.updateRangeFill();
  }

  normaliseInputs() {
    const min_value = this.parseValue(this.min_range.value, this.min);
    const max_value = this.parseValue(this.max_range.value, this.max);

    this.min_input.value = min_value <= this.min ? "" : this.formatValue(min_value);
    this.max_input.value = max_value >= this.max ? "" : this.formatValue(max_value);
  }

  updateRangeFill() {
    const min_value = this.parseValue(this.min_range.value, this.min);
    const max_value = this.parseValue(this.max_range.value, this.max);
    const range = this.max - this.min;
    const min_position = range ? ((min_value - this.min) / range) * 100 : 0;
    const max_position = range ? ((max_value - this.min) / range) * 100 : 100;

    this.range_fill.style.left = `${min_position}%`;
    this.range_fill.style.right = `${100 - max_position}%`;
  }

  parseValue(value, fallback) {
    const parsed_value = Number.parseFloat(String(value).replace(/,/g, ""));

    return Number.isNaN(parsed_value) ? fallback : parsed_value;
  }

  formatValue(value) {
    return Number.isInteger(value) ? String(value) : value.toFixed(2);
  }

  clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }
}
customElements.define("collection-price-range", CollectionPriceRange);

class CollectionCardMedia extends HTMLElement {
  constructor() {
    super();

    this.controls = this.querySelector(".collection-grid-banner__controls");
    this.video = this.querySelector("video");
    this.events = [
      {
        el: this,
        type: "click",
        callback: this.clickHandler.bind(this),
      },
      {
        el: this.video,
        type: "ended",
        callback: this.endedHandler.bind(this),
      },
      {
        el: document,
        type: "scroll",
        callback: this.scrollHandler.bind(this),
      },
    ];
  }

  connectedCallback() {
    if (!this.video) return;

    handleEventListeners(this.events, "add");
  }

  disconnectedCallback() {
    if (!this.video) return;

    handleEventListeners(this.events, "remove");
  }

  clickHandler(e) {
    if (!e.target.closest(".collection-grid-banner__play")) return;

    this.controls.classList.add("hide-controls");
    this.video.play();
  }

  endedHandler(e) {
    if (e.target !== this.video) return;

    this.video.currentTime = 0;
    this.controls.classList.remove("hide-controls");
  }

  scrollHandler(e) {
    if (e.type !== "scroll") return;

    const video_bounds = this.video.getBoundingClientRect();
    const is_in_view = video_bounds.bottom >= 0 && video_bounds.top <= window.innerHeight;

    if (!is_in_view) {
      this.video.pause();
    }
  }
}

customElements.define("collection-card-media", CollectionCardMedia);

class CombinedProductGrid extends HTMLElement {
  constructor() {
    super();

    this.pages = +this.dataset.pages;
  }

  connectedCallback() {
    if (this.pages > 1) {
      this.fetchRemainingProducts();
    }
  }

  async fetchRemainingProducts() {
    const section_id = this.dataset.sectionId;
    const base_params = new URLSearchParams(window.location.search);
    base_params.delete("page");
    base_params.set("section_id", section_id);

    const page_urls = [];
    for (let page_number = 2; page_number <= this.pages; page_number++) {
      const page_params = new URLSearchParams(base_params);
      page_params.set("page", page_number);
      page_urls.push(`${window.location.pathname}?${page_params.toString()}`);
    }

    try {
      const page_responses = await Promise.all(
        page_urls.map(async (page_url) => {
          const response = await fetch(page_url);
          return await response.text();
        }),
      );

      for (const page_html of page_responses) {
        const parsed_doc = new DOMParser().parseFromString(page_html, "text/html");
        const fetched_groups = parsed_doc.querySelectorAll(".combined-product-grid__group");

        for (const fetched_group of fetched_groups) {
          const branding_class = Array.from(fetched_group.classList).find((class_name) =>
            class_name.endsWith("--branding"),
          );
          if (!branding_class) continue;

          const target_list = this.querySelector(`.${branding_class} .group__list-inner`);
          if (!target_list) continue;

          const product_cards = fetched_group.querySelectorAll(".group__list-inner > *");
          product_cards.forEach((product_card) => target_list.appendChild(product_card));
        }
      }
    } catch (error) {
      console.error("CombinedProductGrid: failed to fetch remaining pages", error);
    }
  }
}

customElements.define("combined-product-grid", CombinedProductGrid);
